var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { size } from 'polished';
import { display, fontSize, space } from 'styled-system';
import { stroke } from '../../theme/system-utilities';
import Icon from '../Icon';
var EMAIL_ICON_SIZE = 24;
var SubmitButtonText = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), display, fontSize);
SubmitButtonText.defaultProps = {
    display: ['none', 'block'],
    fontSize: 'fs_16',
};
var SubscribeIcon = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), size(EMAIL_ICON_SIZE), display, space, stroke);
SubscribeIcon.defaultProps = {
    role: 'presentation',
    display: ['block', 'none'],
    stroke: 'gray.0',
    mx: 'sp_16',
};
export var EmailSubmitButton = function (_a) {
    var children = _a.children;
    return (React.createElement(Fragment, null,
        React.createElement(SubscribeIcon, { name: "subscribe" }),
        React.createElement(SubmitButtonText, { "data-testid": "submit-button-label" }, children)));
};
var templateObject_1, templateObject_2;
